export enum DealType {
  Purchase = 'purchase',
  Refinance = 'refinance',
  Startup = 'startup',
}

export enum LoanType {
  Conventional = 'conventional',
  SBA = 'SBA',
}

export enum DealStatus {
  New = 'New',
  Approved = 'Approved',
  Rejected = 'Rejected',
  Pending = 'Pending',
  Closed = 'Closed',
  LostDeal = 'Lost Deal',
}

export interface Customer {
  firstName: string;
  middleName?: string;
  lastName: string;
  email: string;
  phone: string;
  isActive: boolean,
  street: string,
  city: string,
  state: string,
  zipcode: string,
  id: string,
  role: string,
  createdByUser: any;
  createdByBusiness: any;
  dob?: string;
}

export interface Business {
  name: string;
}


export interface Deal {
  id?: string;
  customer: Customer;
  business: Business;
  loanName: string;
  dealType: DealType;
  loanType?: LoanType;
  loanSize: number;
  maxLTV: number;
  minDSCRatio: number;
  status?: DealStatus;
  closingDate?: string | null;
  createdAt?: string;
  updatedAt?: string;
  assignedBanks?: any;
  honor?:string;
  bankerInterestStatus?: string;
  isShareCustomerDetails?: boolean;
  prospectKyc?: {
    fullName: string;
    dob: string;
    city: string;
    street: string;
    state: string;
    zipcode: string;
    idNumber: string;
    expirationDate: string;
    phoneNumber: string;
    email: string;
    idType: string;
    govFile: string;
    addressFile: string;
    companyName: string;
    ownershipDetails: string;
    taxId: string;
    registrationType: string;
    businessOptions: string[];
    businessStreet: string;
    businessCity: string;
    businessState: string;
    businessZipcode: string;
    personalIncome: string;
    businessRevenue: string;
    sourceOfFunds: string;
  };
  businessDocuments?: Array<{
    id: string;
    docName: string;
    filePath: string;
    originalName: string;
    customerFilePath: string
  }>;
}


interface Banker {
  name: string;
  email: string;
  phone: string;
  isActive: boolean,
  street: string,
  city: string,
  state: string,
  zipcode: string,
  id: string,
  role: string,
}

export interface Notification {
  id: string;
  message: string;
  type: string;
  isRead: boolean;
  createdAt: string;
  banker?: Banker;
  deal?: Deal;
}


